"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get down () {
        return down;
    },
    get up () {
        return up;
    }
});
const _globals = require("~/utils/globals");
const up = async (knex)=>{
    await knex.schema.alterTable(_globals.MetaTable.KANBAN_VIEW, (table)=>{
        table.string('fk_grp_col_id', 20);
        table.foreign('fk_grp_col_id').references(`${_globals.MetaTable.COLUMNS}.id`);
        table.string('fk_cover_image_col_id', 20);
        table.foreign('fk_cover_image_col_id').references(`${_globals.MetaTable.COLUMNS}.id`);
        table.text('meta');
    });
};
const down = async (knex)=>{
    await knex.schema.alterTable(_globals.MetaTable.KANBAN_VIEW, (table)=>{
        table.dropColumns('meta');
        table.dropColumns('fk_grp_col_id');
        table.dropColumns('fk_cover_image_col_id');
    });
};
